export const ACTIVITIES_MIN_DURATION_DEFAULT = 0
export const ACTIVITIES_MAX_RESULTS_DEFAULT = 100
